import { render } from "./LayoutsAuthPcHeaderWellLabo.vue?vue&type=template&id=176f2d36&scoped=true&ts=true"
import script from "./LayoutsAuthPcHeaderWellLabo.vue?vue&type=script&lang=ts"
export * from "./LayoutsAuthPcHeaderWellLabo.vue?vue&type=script&lang=ts"

import "./LayoutsAuthPcHeaderWellLabo.vue?vue&type=style&index=0&id=176f2d36&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-176f2d36"]])

export default __exports__